/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Simplified user serializer for org member lists.
 * @export
 * @interface OrgUser
 */
export interface OrgUser {
    /**
     * 
     * @type {number}
     * @memberof OrgUser
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof OrgUser
     */
    readonly entityId: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUser
     */
    readonly firstName: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUser
     */
    readonly lastName: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUser
     */
    readonly email: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUser
     */
    readonly displayName: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUser
     */
    readonly avatarUrl: string;
}

/**
 * Check if a given object implements the OrgUser interface.
 */
export function instanceOfOrgUser(value: object): value is OrgUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function OrgUserFromJSON(json: any): OrgUser {
    return OrgUserFromJSONTyped(json, false);
}

export function OrgUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityId': json['entity_id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'displayName': json['display_name'],
        'avatarUrl': json['avatar_url'],
    };
}

  export function OrgUserToJSON(json: any): OrgUser {
      return OrgUserToJSONTyped(json, false);
  }

  export function OrgUserToJSONTyped(value?: Omit<OrgUser, 'id'|'entityId'|'firstName'|'lastName'|'email'|'displayName'|'avatarUrl'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

